
import { Tween } from "./../../Tween";
import PointerEvents from "../../const/PointerEvents";
import Layout from "../../utils/Layout";
import BaseView from "../BaseView";
import TextField from "./TextField";


export default class Link extends BaseView {

    protected textField: TextField;
    protected over: boolean;

    constructor(text: TextField) {
        super();
        this.textField = text;

        this.textField.interactive = true;
        this.textField.on(PointerEvents.OVER, this.onOver, this);
        this.textField.on(PointerEvents.ROLLOUT, this.onOut, this);
        this.textField.on(PointerEvents.UPOUTSIDE, this.onOut, this);
        this.setVisible(false);
        this.setEnabled(false);
    }

    public setVisible(visible: boolean) {
        super.setVisible(visible);
        this.textField.visible = visible;
    }

    public setEnabled(enabled)
    {
        super.setEnabled(enabled);
        this.textField.interactive = enabled;
        this.textField.addUnderline();
        Tween.to(this.textField, .25, {alpha: .5 + .5 * Number(enabled)});
    }

    protected onOver() {
        this.over = true;
        this.textField.removeUnderline();
    }

    protected onOut() {
        this.over = false;
        this.textField.addUnderline();
    }

    public addInteraction(callback: (...args: any[]) => void) {
        this.textField.on(PointerEvents.DOWN, callback);
        this.on(PointerEvents.DOWN, callback);
    }
}